import React from 'react';
import { t } from '../../utils/i18n';
import { CmsHomepageLink } from '../../integrations/contentful/types';
import H from '../elements/H';
import IconText from '../common/IconText';
import { baseXUnit, breakpoints, color } from '../../styles/theme';
import Spacing from '../common/Spacing';
import HyperLink from '../elements/HyperLink';

interface TravellerProfileProps {
  firstName: string;
  homepage?: CmsHomepageLink;
  instagramHandle?: string;
  residence: string;
}

const iconSize = [2, 2, 4];
const instagramUrl = 'https://www.instagram.com/';

const TravellerInformation: React.FunctionComponent<TravellerProfileProps> = ({
  firstName,
  homepage,
  instagramHandle,
  residence
}) => {
  return (
    <div className="traveller-information">
      <Spacing top={2} right={2} left={2}>
        <div className="city">
          <Spacing bottom={2} right={[0, 4, 4]}>
            <IconText icon="travel-house" iconSize={iconSize} iconColor="gray">
              <H styling="h4" tag="div" data-testid="traveller-residence" data>
                {t('Asuu paikkakunnalla')} {residence}
              </H>
            </IconText>
          </Spacing>
        </div>
        {instagramHandle && (
          <div className="instagram">
            <Spacing bottom={2} right={[0, 4, 4]}>
              <IconText
                icon="nav-arrow-right"
                iconSize={iconSize}
                iconColor="purple-light"
              >
                <H styling="h4" tag="div" data>
                  <HyperLink
                    href={instagramUrl + instagramHandle}
                    data-testid="instagram-link"
                  >
                    {firstName} {t('Instagramissa')}
                  </HyperLink>
                </H>
              </IconText>
            </Spacing>
          </div>
        )}
        {homepage && (
          <div className="homepage">
            <Spacing bottom={2}>
              <IconText
                icon="nav-arrow-right"
                iconSize={iconSize}
                iconColor="purple-light"
              >
                <H styling="h4" tag="div" data>
                  <HyperLink
                    className="homepage-link"
                    href={homepage.fields.url}
                    data-testid="homepage-link"
                  >
                    {homepage.fields.linkText}
                  </HyperLink>
                </H>
              </IconText>
            </Spacing>
          </div>
        )}
      </Spacing>
      {/*language=CSS*/}
      <style jsx>{`
        .traveller-information {
          border: 1px solid ${color.light};
          border-radius: ${baseXUnit(1)};
        }
        @media ${breakpoints.medium} {
          .city,
          .instagram,
          .homepage {
            display: inline-block;
          }
        }
      `}</style>
    </div>
  );
};

export default TravellerInformation;
